module.exports = __webpack_public_path__ + "img/2025-05-09c_3.10ccd7f8.jpg";